<template>
  <div
    v-if="isDebugInfoVisible"
    class="debug-wrapper"
  >
    <slot />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { r7eBaseApp } from '@r7e/shared';
const r7eApp = r7eBaseApp.getMainApp();

const isDebugInfoVisible = ref(false);

const debugManagerCallback = (o) => {
    // console.log('DebugWrapper, debugManagerCallback', o);
    isDebugInfoVisible.value = o.visible;
}

onMounted(() => {
    // console.log('DebugWrapper, onMounted');
    const debugManager = r7eApp.getDebugManager();
    if (debugManager) {
        debugManager.registerObserver(debugManagerCallback);
        isDebugInfoVisible.value = debugManager.isVisible();
    } else {
        isDebugInfoVisible.value = false;
    }
});

onUnmounted(() => {
    // console.log('DebugWrapper, onUnmounted');
    const debugManager = r7eApp.getDebugManager();
    if (debugManager) {
        debugManager.unregisterObserver(debugManagerCallback);
    }    
});

</script>
<style scoped>
.debug-wrapper {
    background-color: var(--color-debug-bg);
    color: var(--color-debug-text);
    padding: 10px;
    border-radius: 4px;
    font-size: smaller;
    opacity: 0.5;
}

</style>